import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import AbstractButton from 'jitsi/base/toolbox/components/AbstractButton';
import { IconCameraFlip } from 'jitsi/base/icons/svg';
import { getCurrentCameraDeviceId } from 'jitsi/base/settings/functions.web';
import { setVideoInputDeviceAndUpdateSettings } from 'jitsi/base/devices/actions.web';
import { getLocalJitsiVideoTrack, isLocalTrackMuted } from 'jitsi/base/tracks/functions.any';
import { isVideoMuteButtonDisabled } from 'jitsi/toolbox/functions.web';
import { IGUMPendingState } from 'jitsi/base/media/types';
import { MEDIA_TYPE } from 'jitsi/base/media/constants';
import { equals } from 'jitsi/base/redux/functions';
const selectProperCamera = (target, otherSideID, trackData) => {
    const candidateCameras = trackData.filter((track) => track.deviceId !== otherSideID);
    if (candidateCameras.length === 1)
        return candidateCameras[0].deviceId;
    if (target === 'front') {
        const frontCamera = candidateCameras.find((camera) => !!camera.label.match(/front/i));
        if (frontCamera)
            return frontCamera.deviceId;
    }
    else {
        const backCamera = candidateCameras.find((camera) => !!camera.label.match(/back/i));
        if (backCamera)
            return backCamera.deviceId;
    }
    return candidateCameras.sort((a, b) => a.label.length - b.label.length)[0].deviceId;
};
class CameraFlipButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.cameraFlip';
    icon = IconCameraFlip;
    label = 'toolbar.cameraFlip';
    toggledIcon = IconCameraFlip;
    toggledAccessibilityLabel = 'toolbar.cameraFlip';
    tooltip = 'toolbar.accessibilityLabel.cameraFlip';
    toggledLabel = 'toolbar.cameraFlip';
    toggledTooltip = 'toolbar.cameraFlip';
    constructor(props) {
        super(props);
        this.state = {
            frontCamera: null,
            backCamera: null,
        };
        this._setCameras = this._setCameras.bind(this);
        this._flipCamera = this._flipCamera.bind(this);
    }
    async _setCameras() {
        const { videoInputs: devices, openedCameraMode, currentCameraDeviceId } = this.props;
        const { frontCamera, backCamera } = this.state;
        if (!devices)
            return;
        let newCameras = {};
        const isFrontOperating = devices.find((value) => value.deviceId === frontCamera);
        const isBackOperating = devices.find((value) => value.deviceId === backCamera);
        if (frontCamera && backCamera) {
            if (isFrontOperating && isBackOperating)
                return;
            else if (!isFrontOperating && !isBackOperating) {
                if (openedCameraMode === 'user')
                    newCameras = {
                        frontCamera: currentCameraDeviceId,
                        backCamera: selectProperCamera('back', currentCameraDeviceId, devices),
                    };
                else
                    newCameras = {
                        backCamera: currentCameraDeviceId,
                        frontCamera: selectProperCamera('front', currentCameraDeviceId, devices),
                    };
            }
        }
        if (!frontCamera && isBackOperating)
            newCameras = {
                frontCamera: selectProperCamera('front', backCamera, devices),
            };
        else if (!backCamera && isFrontOperating)
            newCameras = {
                backCamera: selectProperCamera('back', frontCamera, devices),
            };
        else {
            if (openedCameraMode === 'user')
                newCameras = {
                    frontCamera: currentCameraDeviceId,
                    backCamera: selectProperCamera('back', currentCameraDeviceId, devices),
                };
            else
                newCameras = {
                    backCamera: currentCameraDeviceId,
                    frontCamera: selectProperCamera('front', currentCameraDeviceId, devices),
                };
        }
        this.setState((prevState) => ({ ...prevState, ...newCameras }));
    }
    _isDisabled() {
        return this.props.disabled;
    }
    componentDidUpdate(prevProps) {
        if (!this.props.openedCameraMode || !this.props.videoInputs)
            return;
        const cameraID = this.props.currentCameraDeviceId;
        const isCameraIDAvailable = cameraID && cameraID !== '';
        if (!isCameraIDAvailable)
            return;
        if (!this.state.frontCamera || !this.state.backCamera)
            this._setCameras();
        else if (!equals(this.props.videoInputs, prevProps.videoInputs)) {
            this._setCameras();
        }
    }
    _flipCamera() {
        const { openedCameraMode, setVideoInputDevice } = this.props;
        const deviceId = openedCameraMode === 'user' ? this.state.backCamera : this.state.frontCamera;
        setVideoInputDevice(deviceId);
    }
    _handleClick() {
        return this._flipCamera();
    }
}
const mapStateToProps = (state) => {
    const tracks = state['features/base/tracks'];
    const { videoInput: videoInputs } = state['features/base/devices'].availableDevices;
    const { enabled: audioOnly } = state['features/base/audio-only'];
    const openedCameraMode = getLocalJitsiVideoTrack(state)?._facingMode;
    const { gumPending } = state['features/base/media'].video;
    const disabled = Boolean(audioOnly) ||
        gumPending === IGUMPendingState.PENDING_UNMUTE ||
        isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO) ||
        isVideoMuteButtonDisabled(state);
    return {
        disabled,
        videoInputs,
        openedCameraMode,
        currentCameraDeviceId: getCurrentCameraDeviceId(state),
    };
};
const mapDispatchToProps = {
    setVideoInputDevice: setVideoInputDeviceAndUpdateSettings,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(CameraFlipButton));
